
import { Component, Mixins } from "vue-property-decorator";
import { User } from "../../../../../../../domain/user";
import { Department } from "../../../../../../../domain/department";
import { IItem } from "../../../../../../../domain/document/items";
import { UsersValueAccessor } from "../accessors";
import { default as ObjectReferableContentMixin } from "./ObjectReferableContentMixin.vue";

@Component
export default class UserSelectableContentMixin extends Mixins(ObjectReferableContentMixin) {
  data() {
    return {
      accessor: null as UsersValueAccessor,
      error: "",
    };
  }
  accessor: UsersValueAccessor;
  error: string;

  mounted() {
    this.createAccessor(this.item);
  }

  get isAccessorEnable(): boolean {
    return !!this.accessor;
  }

  get defaultSelectedDepartment(): Department {
    return this.$store.getters.department;
  }

  get users(): User[] {
    return this.accessor
      ? this.accessor.get()
      : [];
  }

  set users(value: User[]) {
    if (this.accessor) {
      this.updateItem(this.accessor.set(value));
    }
  }

  createAccessor(newValue: IItem) {
    try {
      this.accessor = new UsersValueAccessor(newValue, this.editingSource, this.defaultSelectedDepartment, this.itemSetId);
      this.accessor.validate();
      this.error = "";
    } catch (e) {
      this.accessor = null;
      this.error = e.message;
    }
  }
}
